import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyValueBlockModule } from 'ngx-zcs-components';
import { IonicModule } from '@ionic/angular';

import { SystemTotalizerComponent } from './system-totalizer.component';
import { ComponentsModule } from '../components/components.module';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    SystemTotalizerComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    ComponentsModule,
    IonicModule,
    KeyValueBlockModule,
  ],
  exports: [
    SystemTotalizerComponent,
  ],
})
export class SystemTotalizerModule { }
